<template>
    <router-link :to="{name: 'program-fiche', params: {id: program.id}}" class="style--default d-block mb-3">
        <simple-card
                imageRounded="circle"
                :image="DEFAULT_IMAGE"
                class="card--style ">
            <div class="d-flex justify-content-between align-items-center w-100">
                <div>
                    <div class="font-weight-bold">
                        {{ou.fullName}}
                        <span class="font-weight-normal text-dark">({{todoCount}} {{todoLabel}})</span>
                    </div>
                    <p class="text-muted mb-0">
                        {{program.name}}
                    </p>
                </div>
            </div>
        </simple-card>
    </router-link>
</template>

<style lang="scss" scoped>
    .card--style{
        background-color: white;
        padding: 0.2em 0.5em 0.2em 0.5em;
        box-shadow: -1px 5px 5px -4px lightgray;
        width: 100%;
    }
</style>

<script>
    import SimpleCard from "../SimpleCard";
    import {DEFAULT_IMAGE} from '@/utils/constants'
    import moment from 'moment'

    export default {
        name: 'program-detail',
        components: {SimpleCard},
        props: {
            program: Object
        },
        data: () => ({
            DEFAULT_IMAGE,
            moment,
            today: null
        }),
        mounted() {
            this.today = moment().unix()
        },
        computed: {
            ou() {
                return this.program.programmeOUs[0].ou
            },
            todoCount() {
                return this.program.programmeEtapes.filter((pe) => {
                    return pe.workflowState === 'todo' && moment(pe.date.date).unix() <= this.today
                }).length
            },
            todoLabel() {
                return this.todoCount > 1 ? 'tâches restantes' : 'tâche restante'
            }
        }
    }
</script>
